export default {
  init() {

  },
  finalize() {
    // Back goes to previous page in search history.
    $('.right-search-close-btn, .mobile-search-close-btn').on('click', function(e) {
      history.go(-1);
      e.preventDefault();
    });

    // Select search suggestion
    $('.search-home-suggestion').on('click', function() {
      $('#search-query').val($(this).html());
      searchFromHome($(this).html());
    });

    // Search (from home)
    $('#search-home-form').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const q = $(this).find('#search-query').val();
      searchFromHome(q);
    });

    // Search (from results)
    $('#search-results-form').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const q = $(this).find('#search-results-query').val();
      doSearch(q);
    });

    function searchFromHome(q) {
      if (q != '') {
        doSearch(q);

        $('.search-home').addClass('hide');
        $('#search-results-query').val(q);

        setTimeout(() => {
          $('.global-navbar-wrap').addClass('no-banner');
          $('.global-mobile-navbar-wrap').addClass('no-banner');
        }, 1100);
      }
    }

    function doSearch(query) {
      // Clear the results wrap
      $('.search-results-listing .listing-inner').empty();
      $('.search-results-listing').show();
      $('.search-results-not-found').hide();

      if (query == '') {
        // reset.
        $('#search-query').val('');
        $('#search-results-query').val('');
        $('.search-home').removeClass('hide');
        $('.global-navbar-wrap').removeClass('no-banner');
        $('.global-mobile-navbar-wrap').removeClass('no-banner');
      } else {
        // Send the AJAX request.
        $.ajax({
          url: '/wp-json/search/v1/get',
          method: 'GET',
          data: {
            q: query,
          },
        }).done(function(e) {

          if (Array.isArray(e)) {

            if (e.length == 0) {
              // No results.
              $('.search-results-listing').hide();
              $('.search-results-not-found').show();
            } else {

              e.forEach((searchResult) => {
                const $searchResult = $('.search-result-dummy').clone().appendTo('.search-results-listing .listing-inner');
                $searchResult.find('.search-result-title').html(searchResult.title);
                $searchResult.find('.search-result-description').html(searchResult.synopsis);
                $searchResult.find('.search-result-link').prop('href', searchResult.link);

                if (searchResult.thumb !== false) {
                  $searchResult.find('.search-result-image').prop('src', searchResult.thumb);
                } else {
                  $searchResult.find('.search-result-image').hide();
                }

                $searchResult.removeClass('search-result-dummy');
                $searchResult.addClass('search-result');

              });

            }

          }

        });
      }
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateSearchPage.js